// TODO: This file was created by bulk-decaffeinate.
// Sanity-check the conversion and remove this comment.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS208: Avoid top-level this
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
const AdvancedDatepickers = () => ({
   replace: true,
   controller: 'AdvancedDatepickersCtrl',
   templateUrl: '/assets/advancedSearch/advancedDatepickers.html'
})

const JournalTitleRecommendation = (jtService: any) => ({
   replace: true,
   templateUrl: '/assets/journalTitleRecommendation.html',

   link($scope: any){
      return $scope.jt || ($scope.jt = jtService.jt)
   }
})

const AdvancedCheckboxes = (translationService: any, $facetTypes: any) => ({
   replace: true,
   templateUrl: '/assets/advancedSearch/advancedCheckboxes.html',

   scope: {
      filter: "=",
      values: "=",
      onChange: "&",
      blockName: "=",
      scopeBuilderMode: "<?"
   },

   link(scope: any) {
      scope.i18n = translationService
      const getFilterClasses = (filter: any) => {
         if (filter.disabled) { 
            return {
               applied: filter.applied,
               disabledFacet: filter.disabled
            }
         }
      }
      const orderBy = () => {
         if (scope.blockName != $facetTypes.REFINE_PANE){ //let's every field be order alphabetically or by value except "Refine your search" which is customize by the client
            return scope.values[0].orderBy
         }
      }
      scope.getFilterClasses = getFilterClasses
      return scope.orderBy = orderBy      
   }
})

const AdvancedSearchDialog = () => ({
   replace: true,
   controller: 'AdvancedSearchCtrl',
   templateUrl: '/assets/advancedSearchDialog.html',

   link(s: any) {
      return s.advanced.syncWithState()
   }
})

const AdvancedSearchFooter = () => ({
   replace: true,
   templateUrl: '/assets/advancedSearch/advancedSearchFooter.html'
})

// @ts-expect-error TS(7006) FIXME: Parameter 'translation' implicitly has an 'any' ty... Remove this comment to see the full error message
const AdvancedBlock = (translation, facets, advancedSearchService) => ({
   replace: true,
   templateUrl: '/assets/advancedSearch/advancedBlock.html',

   scope: { 
      blockName: "@",
      scopeBuilderMode: "<?",
      advanced: "=",
      facetObject: "="
   },

   link(scope: any) {
      scope.i18n = translation
      scope.label = advancedSearchService.get('label', scope.blockName)
      return scope.sortFacet = advancedSearchService.sortFacetType
   }
})

angular.module('summonApp.directives')
   .directive('advancedDatepickers', AdvancedDatepickers)
   .directive('advancedCheckboxes', ['translationService', '$facetTypes', AdvancedCheckboxes])
   .directive('journalTitleRecommendation', ['journalTitleService', JournalTitleRecommendation])
   .directive('advancedBlock', ['translationService', 'facetsService', 'advancedSearchService', AdvancedBlock])
   .directive('advancedSearchDialog', AdvancedSearchDialog)
   .directive('advancedSearchFooter', AdvancedSearchFooter)
